import { useEffect } from 'react';
export var useResizeObserver = function (ref, callback) {
    useEffect(function () {
        var resizeObserver = new window.ResizeObserver(function (entries) {
            callback(entries[0].contentRect);
        });
        resizeObserver.observe(ref.current);
    }, [ref]);
};
